import _ from "lodash";
/** internal */
import React, { useState, useEffect, memo } from "react";
import PropTypes from "prop-types";
/** external */
import SlickSlider from "UIComponents/SlickSlider";
/** relative */
import classes from "./WorksheetCarousel.scss";

const styles = {
  customPrevArrowStyle: {
    background: "none",
    boxShadow: "none",
    margin: "unset",
  },
  customNextArrowStyle: {
    background: "none",
    boxShadow: "none",
    margin: "unset",
  },
};

const WorksheetCarousel = memo(props => {
  const { updatePageNumber, attachmentData, updateIsUrlLoading } = props;

  const [thumbUrls, setThumbUrls] = useState([]);

  const getPageThumbUrls = () => {
    const workbookUrl = _.get(attachmentData, "metadata.workbookUrl");
    const pageThumbUrlsData = _.get(attachmentData, "metadata.pageThumbUrls");
    // To fetch updated urls
    return _.map(_.get(pageThumbUrlsData, workbookUrl, []), "imageUrl") || [];
  };

  useEffect(() => {
    const pageThumbUrls = getPageThumbUrls();
    if (!_.isEmpty(pageThumbUrls)) {
      setThumbUrls(pageThumbUrls);
      updateIsUrlLoading(false);
    } else {
      const firstUrl = _.get(attachmentData, "thumbUrl");
      // create an array with firstUrl repeated twice to show right arrow
      setThumbUrls([firstUrl, firstUrl]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attachmentData]);

  const afterChange = pageNumber => {
    const pageThumbUrls = getPageThumbUrls();
    if (_.isEmpty(pageThumbUrls)) {
      updateIsUrlLoading(true);
      updatePageNumber(1);
    } else {
      updatePageNumber(pageNumber + 1);
    }
  };

  const renderItem = ({ item }) => (
    <img src={item} alt="" className={classes.img} />
  );
  return (
    <SlickSlider
      items={thumbUrls}
      renderItem={renderItem}
      showDots={false}
      variableWidth={false}
      afterChange={afterChange}
      customPrevArrowStyle={styles.customPrevArrowStyle}
      customNextArrowStyle={styles.customNextArrowStyle}
    />
  );
});

WorksheetCarousel.prototype = {
  updatePageNumber: PropTypes.func,
  attachmentData: PropTypes.object,
  updateIsUrlLoading: PropTypes.func,
};

WorksheetCarousel.displayName = "WorksheetCarousel";

export default WorksheetCarousel;
